import {Module} from 'vuex';
import {WeatherMapType, WeatherMapTypeFilter} from '@/weather/WeatherModels';
import {listWeatherMapTypes} from '@/weather/maps/admin/WeatherMapTypeService';
import {listWeatherMapTypeFilters} from '@/weather/maps/admin/WeatherMapTypeFilterService';

interface WeatherStoreState {
  publicFilters: WeatherMapTypeFilter[];
  mapTypes: WeatherMapType[];
}

export default {
  namespaced: true,
  state: {
    publicFilters: [],
    mapTypes: []
  },
  getters: {},
  actions: {
    async refreshPublicFilters({commit}) {
      commit('setPublicFilters', await listWeatherMapTypeFilters());
    },
    async refreshMapTypes({commit}) {
      commit('setMapTypes', await listWeatherMapTypes());
    },
    async load({state, commit}) {
      const promises: Promise<any>[] = [];
      // Push the promise for each type that hasn't yet been loaded with a unique (arbitrary) type
      if (state.publicFilters.length === 0) {
        promises.push(listWeatherMapTypeFilters().then((filter) => ({id: 2, results: filter})));
      }
      if (state.mapTypes.length === 0) {
        promises.push(listWeatherMapTypes().then((weatherMapType) => ({id: 4, results: weatherMapType})));
      }

      // When all are complete set the data for each type that returned data.
      (await Promise.all(promises)).forEach((result) => {
        switch (result.id) {
          case 2:
            commit('setPublicFilters', result.results);
            break;
          case 4:
            commit('setMapTypes', result.results);
            break;
        }
      });
    }
  },
  mutations: {
    setPublicFilters(state, publicFilters: WeatherMapTypeFilter[]) {
      state.publicFilters = publicFilters;
    },
    setMapTypes(state, mapTypes: WeatherMapType[]) {
      state.mapTypes = mapTypes;
    }
  },
} as Module<WeatherStoreState, any>;
